<!--
 * @Description: el-pagination
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2021-04-22 10:45:05
 * @LastEditors: FJW
 * @LastEditTime: 2024-10-22 09:47:21
-->
<template>
  <div class="marT10" :class="align">
    <el-pagination :current-page.sync="currentPage" :page-size.sync="pageSize" :layout="layout" :page-sizes="pageSizes" :total="total" :pager-count="5" @size-change="handleSizeChange" v-bind="$attrs" @current-change="handleCurrentChange" />
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        this.$emit('update:limit', this.limit)
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  props: {
    // 位置
    align: {
      type: String,
      default: 'align-left'
    },
    // 总数
    total: {
      required: true,
      type: Number
    },
    // 当前页码
    page: {
      type: Number,
      default: 1
    },
    // 每页条数
    limit: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100]
      }
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next, jumper'
    }
  },

  data() {
    return {
      key: 'thequickbrownfox',
      iv: 'jumpsoverlazydog'
    }
  },

  methods: {
    handleSizeChange(val) {
      this.$emit('getPageChange', { page: this.currentPage, limit: val })
    },

    handleCurrentChange(val) {
      this.$emit('getPageChange', { page: val, limit: this.pageSize })
    }
  }
}
</script>